module.exports = __webpack_public_path__ + "img/assertiveness_count.eb4a132e.png";